import React from 'react';
import PropTypes from 'prop-types';
import { FormRow } from '@here/ref-client-ui';
import RfAutocomplete from '../shared/autocomplete';
import './inputSearch.scss';
import { useSelector } from 'react-redux';
import { getSupportedCountries } from '../../state/countries';

function CountryFilter({ setSearch , setSelectedForm }) {
  const onSelect = (value) => {
    setSearch(value);
  };

  const data = useSelector(getSupportedCountries);  

  return (
    <FormRow className="rf-input-search">
      <RfAutocomplete
        placeholder="Country search"
        label="Country search"
        data={data}
        onSelect={onSelect}
        showListRegex={/[a-zA-Z0-9]{1}/}
        fullWidth={true}
        setSelectedForm={setSelectedForm}
      />
    </FormRow>
  );
}

CountryFilter.propTypes = {
  setSearch: PropTypes.func.isRequired,
};

export default CountryFilter;
